import { useAppContext, useTranslator } from '@front-activerse/common-components';

const ReturningUserInfo: React.FC = () => {
  const { t } = useTranslator();
  const {
    consts: { OPEN_APP_URL },
  } = useAppContext();

  return (
    <section>
      <h2 className="title-large semi-bold text-center mb-xl">
        {t('app.thankUPage.returningUser.title')}
      </h2>
      <p className="text-center text-text-variant-color">
        {t('app.thankUPage.returningUser.description')}
      </p>
      <a className="btn btn-primary w-100 mt-3" href={String(OPEN_APP_URL)}>
        {t('app.thankUPage.returningUser.openApp.button')}
      </a>
    </section>
  );
};

export default ReturningUserInfo;
